import React, {Component} from 'react';
import PropTypes from 'prop-types';

import LogoText from '../../media/svg/logo-twineeds.svg';

import './LoginLayout.scss';

export default class LoginLayout extends Component {
  static propTypes = {
    helmet: PropTypes.element,
  };

  static defaultProps = {
    helmet: null,
  };

  render() {
    return (
      <div className="login-layout d-flex align-items-center">
        {this.props.helmet}
        <div className="row align-items-center">
          <div className="col-10 p-4 p-md-5">
            <div className="logo mb-4">
              <LogoText/>
            </div>
            {this.props.children}
          </div>
        </div>
        <div className="d-none d-xl-block"/>
      </div>
    );
  }
}
